import {FC, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  selectOrderPaymentMethod,
  selectOrderShippingAddress,
  selectViewOrder,
  setChangeShippingAddress,
  setChangePaymentMethod,
  selectOrderBillingAddress,
  updateShippingAddress,
  setIsShippingAddressSame,
} from 'app/features/orders/redux/order/orderEditSlice'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {EditCustomerInOrder} from 'app/features/orders/componentsv1/edit'
import {financialStatusTypes} from 'app/utilities'
import {ShippingMethodDialog} from '../deliveryMethodAction'
import {mapToAddress} from '../../../../redux/order/helper'

interface Props {}

const CustomerWrapper: FC<Props> = () => {
  const dispatch = useDispatch()
  const order = useSelector<RootState, ViewOrder>(selectViewOrder) as any
  const shippingAddress = useSelector<RootState, any>(selectOrderShippingAddress)
  const paymentMethod = useSelector<RootState, any>(selectOrderPaymentMethod)
  const billingAddress = useSelector<RootState, any>(selectOrderBillingAddress)
  const [showDialog, setShowDialog] = useState(false)

  const handleShippingAddressChange = (address: any) => {
    if (address.id === order.shippingAddressId) {
      dispatch(setIsShippingAddressSame(true))
    } else {
      dispatch(setIsShippingAddressSame(false))
    }
    const orderShippingAddress = mapToAddress(
      order.orderAddressProfiles?.nodes,
      order.shippingAddress,
      'shipping'
    )
    if (
      address.city === orderShippingAddress.city &&
      address.zipCode === orderShippingAddress.zipCode
    ) {
      dispatch(updateShippingAddress(address))
    } else {
      dispatch(setChangeShippingAddress(address))
      setShowDialog(true)
    }
  }

  const handlePaymentChange = async (pm: any) => {
    dispatch(setChangePaymentMethod(pm))
    return true
  }

  const handleCloseDialog = () => {
    setShowDialog(false)
  }

  const isHidePaymentMethod = useMemo(() => {
    if (order.financialStatus === financialStatusTypes.paymentFailed) {
      return false
    }
    if (order.financialStatus === financialStatusTypes.unPaid) {
      return false
    }
    return true
  }, [order.financialStatus])

  return (
    <>
      <EditCustomerInOrder
        {...order.customer}
        {...order}
        orderType={order.orderType}
        paymentMethod={paymentMethod}
        isHidePaymentMethodChange={isHidePaymentMethod}
        shippingAddress={shippingAddress}
        billingAddress={billingAddress}
        onChangePaymentMethod={handlePaymentChange}
        onChangeShippingAddress={handleShippingAddressChange}
      />
      {showDialog && <ShippingMethodDialog onClose={handleCloseDialog} />}
    </>
  )
}

export default CustomerWrapper
